import { Guid } from 'guid-typescript';

export interface DevisState {
  AgreementId?: Guid;
  NumeroDevis: string;
  DevisId?: Guid;
  DevisStatus?: number;
  TarifId?: string;
  PrimeMensuelle?: number;
  PrimeAnnuelle?: number;
  DocumentDevis?: DownloadableFile;
  DocumentFIC?: DownloadableFile;
  DocumentInfo?: DownloadableFile;
  DocumentCG?: DownloadableFile;
  GDAPositif: boolean;
  PPEPositif: boolean;
  ClientAdvisorFullName: string;
}

export interface DownloadableFile {
  documentTypeCode: string;
  documentId: string;
}

export const initialDevisState: DevisState = {
  AgreementId: undefined,
  NumeroDevis: '',
  DevisId: undefined,
  DevisStatus: undefined,
  TarifId: undefined,
  PrimeMensuelle: undefined,
  PrimeAnnuelle: undefined,
  DocumentDevis: undefined,
  DocumentFIC: undefined,
  DocumentInfo: undefined,
  DocumentCG: undefined,
  GDAPositif: false,
  PPEPositif: false,
  ClientAdvisorFullName: '',
};
